/* Step 3 · rule 3 (B-3a) — the engagement's 105(a) figures (the one materiality) for a screen that shows or defaults from
   them (Sampling's tolerable misstatement): GET /engagements/{id}/materiality-figures, refreshed when 105(a) is saved
   ("materiality-changed"). Never the engagement fields (a mirror), never a default: {} while not set or not loaded. */
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function useMaterialityFigures(engId) {
  const [fig, setFig] = useState({});
  useEffect(() => {
    if (!engId) { setFig({}); return undefined; }
    let live = true;
    const load = () => Promise.resolve(api.get(`/engagements/${engId}/materiality-figures`, { _silent: true }))
      .then((r) => { if (live) setFig((r && r.data) || {}); })
      .catch(() => { if (live) setFig({}); });
    load();
    window.addEventListener("materiality-changed", load);
    return () => { live = false; window.removeEventListener("materiality-changed", load); };
  }, [engId]);
  return fig;
}
